(() => {
  const triggers = Array.from(document.querySelectorAll('#tsv-currency-trigger'));
  if (!triggers.length) return;

  const GLOBE = '<svg class="tsv-loc-globe" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.6 2.5 15.4 0 18M12 3c-2.5 2.6-2.5 15.4 0 18"/></svg>';
  const LANG_FLAG = { en: 'ie', fr: 'fr', de: 'de', it: 'it', es: 'es', sv: 'se', pt: 'pt', nl: 'nl', da: 'dk', pl: 'pl', cs: 'cz', hu: 'hu', ro: 'ro' };
  function langFlag(iso) {
    const cc = LANG_FLAG[String(iso || '').slice(0, 2).toLowerCase()];
    return cc ? '<img class="tsv-loc-flag" src="https://flagcdn.com/w40/' + cc + '.png" width="24" height="16" alt="" loading="lazy">' : GLOBE;
  }

  function findForm(id) {
    const root = document.querySelector('.desktop-localization-wrapper');
    return root ? (root.querySelector(id) || root.querySelector('form.localization-form')) : null;
  }
  function findList(id) { const f = findForm(id); return f ? f.querySelector('.disclosure__list, [role="listbox"]') : null; }
  const findCountryList = () => findList('#HeaderCountryForm');
  const findLanguageList = () => findList('#HeaderLanguageForm');

  if (!document.getElementById('tsv-loc-shelf-style')) {
    const st = document.createElement('style');
    st.id = 'tsv-loc-shelf-style';
    st.textContent =
      '.tsv-loc-overlay{position:fixed;left:0;right:0;bottom:0;top:0;z-index:10050;background:rgba(15,18,22,.42);opacity:0;pointer-events:none;transition:opacity .3s ease;overflow:hidden}' +
      '.tsv-loc-overlay.is-open{opacity:1;pointer-events:auto}' +
      '.tsv-loc-shelf{position:absolute;left:0;right:0;top:0;display:flex;justify-content:center;padding:0 16px}' +
      '.tsv-loc-overlay .tsv-currency-popover{position:relative!important;width:min(880px,100%)!important;max-width:880px!important;max-height:calc(100vh - 130px)!important;overflow:hidden!important;display:flex!important;flex-direction:column!important;background:#fff!important;border-top:3px solid #5a6e84!important;border-radius:0!important;box-shadow:0 26px 50px rgba(0,0,0,.24)!important;padding:0!important;transform:translateY(-100%);transition:transform .42s cubic-bezier(.22,.61,.36,1)}' +
      '.tsv-loc-overlay.is-open .tsv-currency-popover{transform:translateY(0)}' +
      '.tsv-loc-overlay .tsv-currency-popover::before{display:none!important}' +
      '.tsv-loc-head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:15px 22px;border-bottom:1px solid #eef1f4;flex:0 0 auto}' +
      '.tsv-loc-title{font-size:16px;font-weight:700;color:#12161a}' +
      '.tsv-loc-sub{font-size:12.5px;color:#7a8794;margin-top:2px}' +
      '.tsv-loc-headr{display:flex;align-items:center;gap:10px;flex:0 0 auto}' +
      '.tsv-loc-chip{display:inline-flex;align-items:center;gap:7px;background:#f2f5f8;color:#3a4653;font-size:12px;font-weight:600;padding:6px 12px;border-radius:4px;white-space:nowrap}' +
      '.tsv-loc-chip .tsv-loc-globe{color:#5a6e84}' +
      '.tsv-loc-close{position:absolute;top:12px;right:14px;z-index:3;width:34px;height:34px;border:0;border-radius:50%;background:#f1f4f7;color:#5c6773;font-size:19px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .14s ease,color .14s ease}' +
      '.tsv-loc-close:hover{background:#e2e8ee;color:#2b333b}' +
      '.tsv-loc-close:hover{background:#e6ebf0}' +
      '.tsv-loc-cols{display:block;overflow-y:auto;flex:1 1 auto;min-height:0;padding:2px 0 6px}' +
      '.tsv-loc-col{padding:4px 18px 10px}' +
      '.tsv-loc-overlay .tsv-loc-heading{font-size:12px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#12161a;text-align:center;padding:2px 2px 11px;margin:6px 0 14px;border-bottom:2px solid #5a6e84}' +
      '.tsv-loc-overlay .tsv-currency-list{display:block!important;width:100%!important;max-height:none!important;overflow:visible!important;padding:0!important}' +
      '.tsv-loc-overlay .disclosure__list,.tsv-loc-overlay .country-selector__list{width:100%!important;max-width:none!important;display:block!important;position:static!important;inset:auto!important;box-shadow:none!important;border:0!important;background:transparent!important;padding:0!important;margin:0!important}' +
      '.tsv-loc-overlay #tsv-currency-list ul,.tsv-loc-overlay #tsv-language-list ul{display:grid!important;grid-template-columns:repeat(3,1fr)!important;gap:8px!important;width:100%!important;margin:0!important;padding:0!important}' +
      '.tsv-loc-overlay .disclosure__item{display:block!important;width:auto!important;margin:0!important;list-style:none!important}' +
      '.tsv-loc-overlay .disclosure__link{position:relative;display:flex!important;align-items:center!important;width:100%!important;box-sizing:border-box!important;padding:10px 13px!important;margin:0!important;border:1px solid #e4e8ec!important;border-radius:3px!important;background:#fff!important;color:#20262c!important;font-weight:500!important;font-size:14px!important;white-space:nowrap!important;overflow:hidden!important;box-shadow:none!important;transition:background .14s ease,border-color .14s ease,box-shadow .14s ease,transform .14s ease}' +
      '.tsv-loc-overlay .disclosure__link:hover{background:#fbfcfd!important;border-color:#c3ccd6!important;box-shadow:0 2px 8px rgba(20,30,45,.07)!important;transform:translateY(-1px)}' +
      '.tsv-loc-overlay .disclosure__link.tsv-sel{background:#eef2f7!important;border-color:#5a6e84!important;box-shadow:inset 3px 0 0 #5a6e84,0 0 0 1px #5a6e84!important;transform:none}' +
      '.tsv-loc-overlay .disclosure__link.tsv-sel::after{display:none!important}' +
      '.tsv-loc-overlay .tsv-currency-check{display:none!important}' +
      '.tsv-loc-overlay .icon-checkmark{display:none!important}' +
      '.tsv-loc-overlay .tsv-currency-option{display:flex!important;align-items:center!important;gap:11px!important;width:100%!important;min-width:0!important;flex-wrap:nowrap!important;white-space:nowrap!important}' +
      '.tsv-loc-overlay .tsv-currency-option .country{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}' +
      '.tsv-loc-overlay .tsv-currency-meta{background:#eef1f4;color:#5c6773!important;font-size:11px;font-weight:600;letter-spacing:.04em;padding:0 6px;border-radius:3px;line-height:18px;min-width:40px;text-align:center;font-variant-numeric:tabular-nums;margin-left:auto!important;flex:0 0 auto!important;white-space:nowrap!important}' +
      '.tsv-loc-overlay .disclosure__link.tsv-sel .tsv-currency-meta{background:#dbe3ec;color:#39485a!important}' +
      '.tsv-loc-overlay #tsv-language-list .disclosure__link{gap:11px!important}' +
      '.tsv-loc-overlay .tsv-loc-flag,.tsv-loc-overlay .tsv-currency-option img{width:19px;height:13px;border-radius:2px;object-fit:cover;flex:0 0 auto;box-shadow:0 0 0 1px rgba(0,0,0,.06)}' +
      '.tsv-loc-foot{display:flex;justify-content:flex-end;padding:13px 22px;border-top:1px solid #eef1f4;background:#fafbfc;flex:0 0 auto}' +
      '.tsv-loc-apply{background:#5a6e84;color:#fff;border:0;border-radius:4px;padding:12px 34px;font-size:13.5px;font-weight:600;cursor:pointer;transition:background .15s ease}' +
      '.tsv-loc-apply:hover{background:#4c5f74}' +
      '.tsv-loc-apply.is-loading{opacity:.75;cursor:default;background:#5a6e84}' +
      '@media (max-width:640px){.tsv-loc-shelf{padding:0}.tsv-loc-overlay .tsv-currency-popover{width:100%!important;max-width:none!important;border-radius:0!important;max-height:calc(100vh - 90px)!important}.tsv-loc-head{padding:14px 16px}.tsv-loc-title{font-size:15px}.tsv-loc-chip{display:none}.tsv-loc-col{padding:4px 14px 10px}.tsv-loc-overlay #tsv-currency-list ul,.tsv-loc-overlay #tsv-language-list ul{grid-template-columns:1fr 1fr!important;gap:6px!important}.tsv-loc-overlay .disclosure__link{padding:9px 11px!important;font-size:13.5px!important}}';
    document.head.appendChild(st);
  }

  const overlay = document.createElement('div');
  overlay.className = 'tsv-loc-overlay';
  overlay.hidden = true;
  overlay.innerHTML =
    '<div class="tsv-loc-shelf">' +
    '  <div class="tsv-currency-popover" role="dialog" aria-modal="true" aria-label="Choose region, currency and language">' +
    '    <button type="button" class="tsv-loc-close" aria-label="Close">&times;</button>' +
    '    <div class="tsv-loc-cols">' +
    '      <div class="tsv-loc-col" id="tsv-country-section" hidden><div class="tsv-loc-heading">Region &amp; currency</div><div class="tsv-currency-list" id="tsv-currency-list"></div></div>' +
    '    </div>' +
    '    <div class="tsv-loc-foot"><button type="button" class="tsv-loc-apply" id="tsv-loc-apply">Apply</button></div>' +
    '  </div>' +
    '</div>';
  document.body.appendChild(overlay);

  let loaded = false, open = false;
  let selCountry = '', selLocale = '';

  function cleanClone(node) {
    node.querySelectorAll('input[type="search"], .localization-form__search, .disclosure__search, .disclosure__header').forEach((n) => n.remove());
    node.removeAttribute('hidden');
    node.style.display = 'block'; node.style.position = 'static'; node.style.maxHeight = 'none'; node.style.inset = 'auto';
    return node;
  }

  function selectRow(holder, aEl, setter) {
    holder.querySelectorAll('a.tsv-sel').forEach((n) => n.classList.remove('tsv-sel'));
    aEl.classList.add('tsv-sel');
    setter(aEl.getAttribute('data-value') || '');
  }

  function bind(holder, setter) {
    holder.querySelectorAll('a[data-value]').forEach((a) => {
      if (a.getAttribute('aria-current') === 'true') { a.classList.add('tsv-sel'); setter(a.getAttribute('data-value') || ''); }
      a.addEventListener('click', (e) => { e.preventDefault(); selectRow(holder, a, setter); });
    });
  }

  function buildChip() {
    const chip = document.getElementById('tsv-loc-chip');
    if (!chip) return;
    const cCur = document.querySelector('#HeaderCountryForm a[aria-current="true"]');
    const lCur = document.querySelector('#HeaderLanguageForm a[aria-current="true"]');
    const cur = cCur ? ((cCur.querySelector('.tsv-currency-meta') || {}).textContent || '').trim() : '';
    const lang = lCur ? (lCur.textContent || '').replace(/\s+/g, ' ').trim() : '';
    const bits = [cur, lang].filter(Boolean);
    if (!bits.length) return;
    chip.innerHTML = GLOBE + '<span>' + bits.join(' &middot; ') + '</span>';
    chip.hidden = false;
  }

  function loadList() {
    if (loaded) return;

    const cList = findCountryList();

    if (cList) {
      const holder = document.getElementById('tsv-currency-list');
      holder.appendChild(cleanClone(cList.cloneNode(true)));
      document.getElementById('tsv-country-section').hidden = false;
      bind(holder, (v) => { selCountry = v; });
    }

    buildChip();
    loaded = !!cList;
  }

  function applyNow() {
    const btn = document.getElementById('tsv-loc-apply');
    if (btn) { if (btn.disabled) return; btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Updating…'; }
    const cForm = document.querySelector('#HeaderCountryForm');
    const f = document.createElement('form');
    f.method = 'post';
    f.action = cForm ? cForm.getAttribute('action') || cForm.action || '/localization' : '/localization';
    f.style.display = 'none';
    const add = (n, v) => { const i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); };
    add('form_type', 'localization'); add('utf8', '✓'); add('_method', 'put');
    const rt = cForm && cForm.querySelector('[name="return_to"]');
    add('return_to', rt ? rt.value : (window.location.pathname + window.location.search));
    if (selCountry) add('country_code', selCountry);
    if (selLocale) add('locale_code', selLocale);
    document.body.appendChild(f);
    f.submit();
  }

  function anchorTop() {
    const t = triggers.find((b) => b.getBoundingClientRect().width > 0) || triggers[0];
    const icons = t.closest('.header__icons');
    const row = icons ? icons.parentElement : null;
    const y = row ? row.getBoundingClientRect().bottom : (t.getBoundingClientRect().bottom + 14);
    return Math.max(0, Math.round(y));
  }

  function openPanel() {
    loadList();
    overlay.style.top = anchorTop() + 'px';
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    open = true;
  }

  function closePanel() {
    overlay.classList.remove('is-open');
    open = false;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    setTimeout(() => { if (!open) overlay.hidden = true; }, 420);
  }

  triggers.forEach((t) => t.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); open ? closePanel() : openPanel(); }));
  overlay.addEventListener('click', (e) => { if (e.target === overlay || e.target.classList.contains('tsv-loc-shelf')) closePanel(); });
  overlay.querySelector('.tsv-loc-close').addEventListener('click', closePanel);
  overlay.querySelector('#tsv-loc-apply').addEventListener('click', applyNow);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && open) closePanel(); });
  window.addEventListener('resize', () => { if (open) overlay.style.top = anchorTop() + 'px'; });
})();